export const NOTIFICATION_TILES = {
  id_check: {
    title: "This account has not completed their ID check",
    buttonText: "ID Check",
  },
  bank_details: {
    title: "This account has not provided their bank details",
    buttonText: "Bank details",
  },
  payment_hold: {
    title: "This account is on account hold because:",
    buttonText: "",
  },
  account: {
    title: "This account is not registered",
    buttonText: "Invite",
  },
};
